import { useLocation } from "@tanstack/react-router";
import { useInventoryFilter } from "./inventory-filter";
import { useScopedNavigate } from "./scoped-nav";
import { useRole } from "./roles";
import {
  perspectiveIdFromPath,
  defaultPerspective,
  type PerspectivePath,
} from "./perspectives";

// Opening a building in the perspective model = set building scope, then make sure a perspective is
// showing it. There is no `buildings/$id` detail page any more: on a perspective route we simply set
// scope and the page deepens into its building rendering (perspectives read scope from context, not
// the URL); from a neutral route (stock list, groups) we jump to the role's default perspective.
// Callers may force a target — e.g. a freshly-added building → Konfiguraatio for setup.
export function useOpenBuilding() {
  const navigate = useScopedNavigate();
  const location = useLocation();
  const { setBuildingId } = useInventoryFilter();
  const { role } = useRole();

  return (buildingId: string, target?: PerspectivePath) => {
    setBuildingId(buildingId);
    const onPerspective = perspectiveIdFromPath(location.pathname) !== null;
    const to = target ?? (onPerspective ? null : defaultPerspective[role]);
    if (to) void navigate({ to });
  };
}
